import { api } from './base';

import { MutationArg } from 'v2/types';
import { LotteryModel, LotterySettings, LotterySettingsPayload } from 'v2/types/LotteryModel';
import { SWRKeyValue } from 'v2/types/swr';
import { exportFile } from 'v2/utils';

export const lotteriesService = {
  getLotteries(): Promise<LotteryModel[]> {
    return api.get('admin/draw').json();
  },

  createLottery(_key: string, { arg }: MutationArg<Omit<LotteryModel, 'id' | 'participants'>>): Promise<LotteryModel> {
    return api.post('admin/draw', { json: arg }).json();
  },

  updateLottery(
    [_key, lotteryId]: SWRKeyValue,
    { arg }: MutationArg<Omit<LotteryModel, 'id' | 'participants'>>
  ): Promise<LotteryModel> {
    return api.put(`admin/draw/${lotteryId}`, { json: arg }).json();
  },

  deleteLottery([_key, lotteryId]: SWRKeyValue): Promise<void> {
    return api.delete(`admin/draw/${lotteryId}`).json();
  },

  setActiveLottery([_key, lotteryId]: SWRKeyValue, { arg: isActive }: MutationArg<boolean>): Promise<LotteryModel> {
    return api.patch(`admin/draw/${lotteryId}`, { json: { isActive } }).json();
  },

  exportLotteryParticipants([_key, lotteryId]: SWRKeyValue): Promise<void> {
    return api
      .get(`admin/draw/${lotteryId}/export`)
      .blob()
      .then((blob) => exportFile(blob, 'lottery_participants'));
  },

  getLotterySettings(): Promise<LotterySettings> {
    return api.get('v1/admin/simple-draw-settings').json();
  },

  updateLotterySettings(_key: string, { arg }: MutationArg<LotterySettingsPayload>): Promise<LotterySettings> {
    return api.put('v1/admin/simple-draw-settings', { json: arg }).json();
  },
};
